import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

/**
 * Get carts by customer branch
 * - GET {{url}}/portals/customer/carts?branch={id}
 *  - {id} - [mandatory] branch id - to filter different cart list for customer different branch.
 */
const getCarts = () =>
  instance.get(
    `${apiUrls.CARTS}?branch=${store.getters.selectedBranch.id}`
  );

/**
 * Add new carts by customer branch
 * - POST {{url}}/portals/customer/cart
 *  - payload
 *    - productId - [mandatory] product id
 *    - qty - [mandatory] the quantity of the product
 *    - branchId [mandatory] - branch id of the cart
 *  - note: If the productId already exists in Cart of given branchId, it will change to add body.qty amount of existing productId's qty but not create a new record.
 */
const postCart = (payload) =>
  instance.post(apiUrls.CART, payload);

/**
 * Edit cart by customer branch
 * - PATCH {{url}}/portals/customer/cart
 *  - payload
 *    - id - [mandatory] the cart id
 *    - qty - [mandatory] the quantity of the product
 *    - branchId [mandatory] - branch id of the cart
 */
const patchCart = (payload) =>
  instance.patch(apiUrls.CART, payload);

/**
 * Delete cart by customer branch
 * - `DELETE {{url}}/portals/customer/cart
 *  - payload
 *    - id - [mandatory] the cart id
 *    - branchId [mandatory] - branch id of the cart
 */
const deleteCart = (payload) =>
  instance.delete(apiUrls.CART, { data: payload });

export {
  getCarts,
  postCart,
  patchCart,
  deleteCart,
};
